module.exports = __webpack_public_path__ + "img/logo-em_white.e3a6f757.png";